module.exports = __webpack_public_path__ + "static/screen5-cf5956ed56630d2afe1f3d24cd81e249.webp";